import Enum from '@/enum/Enum';

export const FIELD_TYPES_ENUM = Enum({
  TEXT: 'Text',
  DROPDOWNLIST: 'DropdownList',
  MULTISELECT: 'MultiSelect',
  RATING: 'Rating'
});
